var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDatetime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 412,
    height: 240,
    viewBox: "0 0 412 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 412,
    height: 240,
    fill: "var(--card-thumbnail-bg)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33_3516)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.917 36.6667C159.917 36.6667 122.667 74.0001 122.667 120C122.667 166 159.917 203.333 205.917 203.333C252 203.333 289.333 166 289.333 120C289.333 74.0001 252 36.6667 205.917 36.6667ZM206 186.667C169.167 186.667 139.333 156.833 139.333 120C139.333 83.1668 169.167 53.3334 206 53.3334C242.833 53.3334 272.667 83.1668 272.667 120C272.667 156.833 242.833 186.667 206 186.667Z",
    fill: "var(--card-thumbnail-fg)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.167 78.3333H197.667V128.333L241.417 154.583L247.667 144.333L210.167 122.083V78.3333Z",
    fill: "var(--card-thumbnail-fg)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33_3516"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "var(--card-thumbnail-fg)",
    transform: "translate(106 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatetime);
export default __webpack_public_path__ + "static/media/datetime.1701279c1199082741ab569266633268.svg";
export { ForwardRef as ReactComponent };